var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIconImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93971 5.64905L12.9063 0H11.7293L7.41696 4.90495L3.97261 0H0L5.20846 7.41719L0 13.3411H1.17697L5.73099 8.16128L9.36843 13.3411H13.3411L7.93971 5.64905ZM6.32766 7.48256L5.80003 6.74391L1.60105 0.866947H3.40881L6.79738 5.60992L7.32513 6.34845L11.7299 12.5136H9.92219L6.32766 7.48256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconImg);
export default __webpack_public_path__ + "static/media/x-icon-img.444b1e4440f3c394c6db576ec62bed2c.svg";
export { ForwardRef as ReactComponent };